import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { isOnline, statusLine } from "./chatPresence";

// Conversation header: back arrow, avatar (with the live-presence dot), handle,
// and the status line in secondary grey.
//
// ONE header for every conversation, everywhere — main QUSHi and League Play,
// phone and desktop. Client: "Every individual conversation should always show:
// Back arrow, User avatar, Username, Last active. This should be consistent on
// both mobile and desktop."
//
// `onBack` renders the back arrow — every full-screen conversation passes it; the
// desktop two-panel Chats screen does not, because the list it would go back to
// is already on screen beside the thread.
//
// There is no three-dot menu here any more. Client: "When a user opens an
// individual conversation on mobile, there should not be a three dot menu. This
// is a focused conversation screen."
export default function ThreadHeader({ user, onBack }) {
  const status = statusLine(user);
  const handle = user?.user_name?.replace(/^@/, "");

  return (
    <div className="flex items-center gap-3 border-b border-divider bg-white px-4 py-3">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Back"
          className="flex h-8 w-8 flex-shrink-0 items-center justify-center text-gray-900"
        >
          <FontAwesomeIcon icon={faArrowLeft} style={{ width: 17, height: 17 }} />
        </button>
      )}

      <div className="relative flex-shrink-0">
        <img
          src={user?.image}
          alt=""
          className="h-10 w-10 rounded-full object-cover"
        />
        {isOnline(user) && (
          <span className="absolute bottom-0 right-0 block h-3 w-3 rounded-full border-2 border-white bg-presence" />
        )}
      </div>

      {/* flex-1 is the flexible space: this block absorbs the slack, so a long
          handle truncates rather than pushing the row out of shape. */}
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-gray-900">{handle}</p>
        {status && <p className="text-xs text-secondary">{status}</p>}
      </div>
    </div>
  );
}
